import React, { useEffect } from "react";
import "./index.css";

interface Props {
  selectedTarget: "users" | "access-points";
  onTargetChange: (target: "users" | "access-points") => void;
}

const SuspectBehaviorControlPanel: React.FC<Props> = ({
  onTargetChange,
  selectedTarget,
}) => {
  useEffect(() => {
    return () => {
      onTargetChange("users"); // Reset to users when component unmounts
    };
  }, [onTargetChange]);

  return (
    <div className="control-panel">
      <h3>Target Selection</h3>

      {/* Control for selecting target type */}
      <div className="control-group">
        <div className="button-group">
          <button
            className={selectedTarget === "users" ? "active" : ""}
            onClick={() => onTargetChange("users")}
          >
            Users
          </button>
          <button
            className={selectedTarget === "access-points" ? "active" : ""}
            onClick={() => onTargetChange("access-points")}
          >
            Access Points
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuspectBehaviorControlPanel;
